/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RequestedShare { 
    deviceId: number;
    requestedRole: RequestedShare.RequestedRoleEnum;
    email: string;
}
export namespace RequestedShare {
    export const RequestedRoleEnum = {
        Reader: 'READER',
        DataManager: 'DATA_MANAGER',
        Owner: 'OWNER',
        DeviceManager: 'DEVICE_MANAGER'
    } as const;
    export type RequestedRoleEnum = typeof RequestedRoleEnum[keyof typeof RequestedRoleEnum];
}


export type RequestedRoleEnum = typeof RequestedShare.RequestedRoleEnum[keyof typeof RequestedShare.RequestedRoleEnum];
